import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducers from "./rootReducers";
import { composeWithDevTools } from "redux-devtools-extension";
const middleware = applyMiddleware(thunk);

const persistConfig = {
  key: "root",
  storage,
};
const persistedReducer = persistReducer(persistConfig, rootReducers);
const store = createStore(persistedReducer, composeWithDevTools(middleware));
const persistor = persistStore(store);

export { store, persistor };
